import { Icon } from '@/shared/types/icon';

const Firefox = ({ size = 16 }: Icon) => {
  return (
    <svg height={size} width={size} viewBox="0 0 128 128">
      <ellipse fill="#110070" cx="63.833" cy="63.79" rx="59.102" ry="59.14" />
      <radialGradient
        id="firefox-original-a"
        cx="-407.857"
        cy="945.153"
        r="103.81"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#67C5D5" />
        <stop offset=".16" stopColor="#66C2D3" />
        <stop offset=".28" stopColor="#62B9CE" />
        <stop offset=".385" stopColor="#5CA8C6" />
        <stop offset=".483" stopColor="#5392BA" />
        <stop offset=".576" stopColor="#4874AA" />
        <stop offset=".665" stopColor="#3A5097" />
        <stop offset=".749" stopColor="#2A2781" />
        <stop offset=".815" stopColor="#1B006D" />
        <stop offset="1" stopColor="#596AAD" />
      </radialGradient>
      <ellipse fill="url(#firefox-original-a)" cx="63.833" cy="63.79" rx="57.985" ry="58.024" />
      <radialGradient
        id="firefox-original-b"
        cx="-407.874"
        cy="938.23"
        r="52.024"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#0F80BC" />
        <stop offset=".338" stopColor="#0A5F9E" />
        <stop offset="1" stopColor="#00145A" />
      </radialGradient>
      <path
        fill="url(#firefox-original-b)"
        d="M55.516 93.741c-.072-.314-.854-1.227-1.452-1.432-.598-.204-1.184.881-1.568-.92-1.261.724-1.805-.199-1.805-.199s-1.359.08-1.623 1.744c-.647.767-2.306 3.552-1.425.655.887-2.915-.936-.229-1.105 1.236-.316.65-.851.715-.515-2.209-1.168-.404-1.766-3.115-1.125-3.167-.744-1.037-.16-2.622.46-2.538.62.08 1.683-1.354 1.651-1.688-.033-.331.479-.094.448-2.327-.033-2.237.843-2.792.915-.92.075 1.864 1.189-.611 1.075-1.561-.116-.944.11-3.082.79-1.818-.79-3.125-.167-3.247.307-1.168 1.189.094 1.23.727 1.23.727 1.315-.324 1.945.667 2.048 1.223 1.218-1.438 2.45.113 2.45.113s.849-.282.443 1.195c-.409 1.472 1.765.676 1.246-.382 1.068-.541 2.655 1.097 3.155 2.216.5 1.123-.857 2.712.201 3.096 1.063.382.597 2.232.597 2.232s2.224 1.234.68 2.293l-.525 1.26s1.006 1.122 1.349.454c.342-.669.463.68.463.68-.128-.238.247 1.391 1.634 1.733 1.392.34 2.273 2.541.728 2.567-1.54.026-1.659-.016-2.076.883-.416.895-2.381.927-3.4-.232-1.083.367-3.009-.106-2.442-.972-.934.545-1.816-.918-1.087-1.572.73-.649-.41-1.491-.793-.56-.379.932-2.395 1.391-2.254-.194.042-.47 1.116-.745 1.129-.352.197.453.277-.037.196-.096z"
      />
      <radialGradient
        id="firefox-original-c"
        cx="-407.873"
        cy="938.23"
        r="52.023"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#0F80BC" />
        <stop offset=".338" stopColor="#0A5F9E" />
        <stop offset="1" stopColor="#00145A" />
      </radialGradient>
      <path
        fill="url(#firefox-original-c)"
        d="M103.462 48.392c.307.306.914.237 1.249.144.337-.097.29-.336.581-.43.286-.097 1.392.43 1.103 1.578-.67.093-.914.908-.914.908s-.671.286-1.01.144c-.336-.144-.336-.097-.817-.051-.481.051-1.637-.618-.386-.618 1.252 0-.142-.576-.672-.576-.528 0-.096-.526.531-.381-.436-.718-.195-1.247.335-.718z"
      />
      <radialGradient
        id="firefox-original-d"
        cx="-407.877"
        cy="938.233"
        r="52.031"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#0F80BC" />
        <stop offset=".338" stopColor="#0A5F9E" />
        <stop offset="1" stopColor="#00145A" />
      </radialGradient>
      <path
        fill="url(#firefox-original-d)"
        d="M99.125 50.989c-.335.333.05 1.339.482 1.29.43-.047 1.105-.238 1.105-.238s.335.669 0 .862c-.335.19-1.314.106-.046.574 1.298.477 1.633.333 1.729.093.098-.237.528-1.05.771-1.001.192-.43-.673-.813-.192-1.102.478-.287.097-1.337.097-1.337s-.675.047-.963.526c-.289.478-.671-.047-.96-.047a1.295 1.295 0 01-.242.524l-.191-.433c-.002.001-1.35-.046-1.59.289z"
      />
      <radialGradient
        id="firefox-original-e"
        cx="-407.023"
        cy="933.306"
        r="57.157"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#0F80BC" />
        <stop offset=".264" stopColor="#0B629B" />
        <stop offset=".844" stopColor="#031747" />
        <stop offset="1" stopColor="#00022F" />
      </radialGradient>
      <path
        fill="url(#firefox-original-e)"
        d="M90.139 51.777c-.042-.123.382-.619.269.023-.261.457 1.054.867 1.423.359 1.235-1.693-1.166-2.513-2.208-1.726-1.051.794-1.631-.908-.423-1.151 1.204-.243 1.306-2.42-.021-2.428 1.171-.578-.451-2.31-1.792-2.605-.217-1.862-2.181-3.046-3.214-2.371-1.043.678-1.132.56-2.661-.369-1.522-.923-2.255 1.92-1.135 3.164 1.126 1.251.309 3.267.355 2.923 0 0-.424.763-.396 1.048-1.289.437-1.665-1.377-2.465-1.779-.583.76-1.523 1.166-1.523 1.166l.07-1.547s-4.001-2.179-5.23-1.569c-1.515.467-1.873 3.975-.498 4.489 1.378.519-1.728 1.811 1.388 5.095 3.2 3.373 4.438 3.469 5.09 2.92.162-.138.441-.345.781-.576.031.13.083.254.163.372.801 1.204-1.862 2.154-2.233 3.879-.377 1.744-.029 4.987 1.55 5.098.301-1.729 3.257-1.118 1.648.448-1.637 1.596-.488 1.878-.488 1.878s.077 2.991 2.582 2.035c-.073.171-.131.39-.167.629-.7-.141-2.411-.356-2.83.838-.528 1.506-2.763-.511-4.328.166-1.556.671-3.829 2.875-3.063 4.425 1.47-.697 2.595 2.447.542 1.802-2.061-.647-1.661.58-1.661.58s-2.146 1.693-.137 3.494c-.771.119-2.143.978-1.681 2.864 0 0-.881.031-1 1.719-2.877.58-2.701 1.472 1.626.494-1.746.905 1.221 1.333 2.536 1.212 1.317-.12 4.773 1.584 2.176 1.602-2.601.016-1.827 1.289 1.29 1.349 3.111.064 2.784.785 3.246.754.462-.033 2.473 1.554 2.365 2.434-.113.88 2.107 1.794 3.551.785.074.916 3.871.202 4.433-1.449 4.112.628 4.017-.139 3.102-.626-2.059-.314-5.837-3.052-1.74-1.643 4.077 1.405.149-1.107-.925-2.072-2.341-.455-2.46-2.406-2.46-2.406s1.293-.736.273-2.576c2.528-.469 1.001-1.358 1.285-2.207.284-.85 1.568-1.934 2.008-2.021.083-.114.772.023.133.283-.552.005-.16 1.559.5 1.639 2.232.271 1.58-2.644.268-3.23-1.315-.591-.134-2.195.789-1.115.923 1.078 2.982-.133 2.209-1.498 1.228.851 1.89-1.902 1.367-3.481 1.642-1.423 1.588-4.26.319-4.896-.625-.312-.926-.513-1.078-.901.754-.356 1.754-.619 2.147-.268.638.577 2.415-1.014 2.302-2.874.748.41 1.939-3.381.927-4.708 2.317-3.239 1.693-3.533.918-2.99-1.166 1.616-4.994 3.548-2.026.685 2.88-2.779-.767-.671-1.986-.219-1.436 1.797-2.958.933-2.958.933s.064-1.472-1.79-1.503c.857-2.363-.523-1.51-1.007-2.154-.481-.648-.656-2.224-.507-2.626z"
      />
      <radialGradient
        id="firefox-original-f"
        cx="-407.875"
        cy="938.233"
        r="52.03"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#0F80BC" />
        <stop offset=".338" stopColor="#0A5F9E" />
        <stop offset="1" stopColor="#00145A" />
      </radialGradient>
      <path
        fill="url(#firefox-original-f)"
        d="M60.1 28.097c-.359.938 1.173 2.461 1.943 1.971.772-.495 1.877-1.477 1.877-1.477s1.172.942.699 1.613c-.477.669-2.376 1.421.372 1.116 2.82-.311 3.334-.893 3.32-1.431-.015-.536.14-2.458.628-2.592.015-.986-1.917-.895-1.248-1.881.669-.982-.901-2.596-.901-2.596s-1.223.716-1.376 1.88c-.154 1.163-1.298.536-1.84.803.141.582-.026 1.207-.026 1.207l-.708-.626s-2.562 1.164-2.74 2.013z"
      />
      <radialGradient
        id="firefox-original-g"
        cx="-407.873"
        cy="938.232"
        r="52.027"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#0F80BC" />
        <stop offset=".338" stopColor="#0A5F9E" />
        <stop offset="1" stopColor="#00145A" />
      </radialGradient>
      <path
        fill="url(#firefox-original-g)"
        d="M64.685 77.327c-.335.333.049 1.337.48 1.291.433-.049 1.106-.239 1.106-.239s.336.669 0 .861c-.337.19-1.314.108-.048.573 1.297.478 1.635.335 1.731.097.096-.239.528-1.053.769-1.006.194-.429-.673-.812-.193-1.097.482-.29.1-1.34.1-1.34s-.674.047-.963.526c-.288.478-.673-.049-.962-.049a1.31 1.31 0 01-.238.526l-.193-.43c-.002 0-1.35-.048-1.589.287z"
      />
      <defs>
        <ellipse id="firefox-original-h" cx="63.833" cy="63.79" rx="57.985" ry="58.024" />
      </defs>
      <clipPath id="firefox-original-i">
        <use xlinkHref="#firefox-original-h" overflow="visible" />
      </clipPath>
      <linearGradient
        id="firefox-original-j"
        gradientUnits="userSpaceOnUse"
        x1="-396.101"
        y1="935.823"
        x2="-379.307"
        y2="934.391"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset="0" stopColor="#0F80BC" />
        <stop offset=".338" stopColor="#0A5F9E" />
        <stop offset="1" stopColor="#00145A" />
      </linearGradient>
      <path
        clipPath="url(#firefox-original-i)"
        fill="url(#firefox-original-j)"
        d="M65.133 5.647c-.907.203.611 3.49.611 3.49s-.054 2.207.32 2.319c.373.113 2.84.729 4.13 2.337 1.297 1.606.623 2.453-.456 1.988-1.08-.462-.794.956-.794.956s3.258 1.059.798.991c-2.466-.065 1.66 1.735 1.387 1.923-.273.19-.427 1.226-.427 1.226s-2.175.181-.332.955c6.235 2.626-.666 1.917-.666 1.917l-.881 1.083 1.743 2.186 1.34.958s2.821-.941 3.701-1.088c.88-.145 3.102-1.808 3.102-1.808s.666.477.168-.495c-.499-.972 1.834-.539 2.415.185l4.118 1.86a.778.778 0 00.291.374c.803.563-.726 1.529-.571 2.552.155 1.012 1.088 2.693 2.113 2.516-.179-.965 1.844-1.082 1.14-.005-.703 1.071.077 1.051.077 1.051s.65 1.515 2.025.673c-.055.462.227 1.392 1.408 1.453 0 0-.125.505.845.862-.132 1.73.422 1.785.559-.843.244 1.154.988-.469 1.136-1.245.15-.78 1.75-2.494 1.317-.979-.429 1.502 4.716 2.051 5.288.258.575-1.808 2.626-2.751 2.687-3.025.063-.28-4.564-.71-4.053-.492.512.217 1.464-.943 1.11-1.978.574.116.827-2.292-.083-2.915 1.139-2.396.649-2.471.182-1.994-.568 1.2-2.911 3.011-1.322.78 1.603-2.254-.651-.282-1.433.208-.686 1.334-1.891 1.075-1.891 1.075s-.221-.908-1.511-.604c.15-1.606-.65-.834-1.115-1.149-.284-.193-.556-.625-.724-.996 1.111.45 2.602.929 2.345.104-.167-.541 2.103.64 2.182.394l2.838-.394 2.757-1.743C85.38 4.813 65.133 5.647 65.133 5.647z"
      />
      <defs>
        <ellipse id="firefox-original-k" cx="63.833" cy="63.79" rx="57.985" ry="58.024" />
      </defs>
      <clipPath id="firefox-original-l">
        <use xlinkHref="#firefox-original-k" overflow="visible" />
      </clipPath>
      <linearGradient
        id="firefox-original-m"
        gradientUnits="userSpaceOnUse"
        x1="-433.831"
        y1="933.28"
        x2="-443.112"
        y2="919.649"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset="0" stopColor="#0F80BC" />
        <stop offset=".338" stopColor="#0A5F9E" />
        <stop offset="1" stopColor="#00145A" />
      </linearGradient>
      <path
        clipPath="url(#firefox-original-l)"
        fill="url(#firefox-original-m)"
        d="M38.929 10.721c-10.531 4.728-18.477 14.473-18.477 14.473s.934 2.137 1.259 1.979c.329-.155-2.351 5.606-.384 5.93 1.978.325 7.666-3.564 6.611-3.206-1.052.354.593-2.105.593-2.105s2.96-1.313 1.209.202c-1.736 1.505 2.309.186 2.246.494-.064.31.522 1.142.522 1.142s-1.387 1.488.404.889c6.147-2.068.81 1.771.81 1.771l.105 1.307 2.659.463 1.572-.15s1.375-2.426 1.907-3.085c.533-.661 1.024-3.271 1.024-3.271s.799-.083-.212-.466c-1.013-.383.967-1.577 1.878-1.429l4.285-1.331a.812.812 0 00.468.082c.981-.114.487 1.596 1.289 2.241.794.641 2.618 1.26 3.27.468-.781-.592.671-2.003.857-.749.186 1.245.764.719.764.719s1.537-2.643 2.028-4.159c.269.375 2.777-3.296 2.017-5.047-.768-1.773.477-3.442.338-3.701-.142-.254-.893.528-.338.34.559-.191-1.583.769-1.866-2.053-.287-2.878-.705.242-.982 1.165.376 1.502 4.273-6.069 4.273-6.069l5.024-2.049c.001.003-11.434-.954-25.153 5.205z"
      />
      <linearGradient
        id="firefox-original-n"
        gradientUnits="userSpaceOnUse"
        x1="-409.766"
        y1="917.94"
        x2="-409.766"
        y2="940.502"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset=".014" stopOpacity="0" />
        <stop offset=".65" stopColor="#C4E0E3" stopOpacity=".2" />
        <stop offset=".822" stopColor="#C4E0E3" />
        <stop offset=".85" stopColor="#CDE5E8" />
        <stop offset=".944" stopColor="#E8F4F7" />
        <stop offset="1" stopColor="#F2FAFC" />
      </linearGradient>
      <ellipse
        opacity=".5"
        fill="url(#firefox-original-n)"
        cx="62.734"
        cy="27.828"
        rx="30.703"
        ry="19.892"
      />
      <linearGradient
        id="firefox-original-o"
        gradientUnits="userSpaceOnUse"
        x1="-407.946"
        y1="896.271"
        x2="-394.013"
        y2="904.454"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset="0" stopColor="#DF731B" />
        <stop offset=".545" stopColor="#DF731B" />
        <stop offset=".701" stopColor="#EC8811" />
        <stop offset=".859" stopColor="#F4950B" />
        <stop offset="1" stopColor="#F79A09" />
      </linearGradient>
      <path
        fill="url(#firefox-original-o)"
        d="M125.156 47.563l-1.421 9.114s-2.03-16.873-4.519-23.182c-3.815-9.666-5.513-9.588-5.523-9.573 2.554 6.493 2.091 9.981 2.091 9.981s-4.527-12.338-16.498-16.264c-14.175-4.646-21.396-2.968-21.343-2.902.054.065 14.651 2.551 17.24 6.109 0 0-6.201 0-12.372 1.777-.278.08 22.703 2.871 27.402 25.836 0 0-2.519-5.257-5.635-6.149 2.048 6.233 1.523 18.061-.428 23.94-.25.757-.508-3.269-4.352-5 1.23 8.821-.074 22.815-6.195 26.668-.477.3 3.837-13.812.868-8.356-17.727 27.18-38.802 10.997-47.351 5.229 6.862 1.681 14.149.471 18.369-2.414 4.258-2.912 6.776-5.038 9.039-4.536 2.261.506 3.767-1.763 2.01-3.776-1.758-2.018-6.027-4.79-11.802-3.278-4.072 1.066-9.12 5.573-16.825 1.01-6.572-3.895-6.528-7.057-6.528-9.071 0-2.016 1.793-5.08 5.056-4.578 2.922.452 1.382-1.264 4.527 0 .857.345-.086-4.112-1.305-6.968 2.348-4.9 9.964-6.356 10.532-6.786 1.03-.778.464-1.167.815-2.34.329-1.093.539-4.046-7.985-3.229-3.923.375-6.418-4.708-7.236-5.941.265-1.572.69-3.007 1.267-4.322.584-1.197 1.222-2.295 1.86-3.126l.53-.701c1.27-1.482 2.831-2.75 4.703-3.802.977-.552-10.926-.035-16.282 6.945-1.437.188-3.409-.227-5.614-.227-2.762 0-4.933.302-6.942.806-.322.082-.84.037-1.476-.113-1.767-1.832-6.77-6.234-6.999-12.206 0 0-7.273 5.59-6.185 20.828-.096 8.429-2.583 6.02-3.863 10.593-.596 2.167.895 3.799.895 3.863-.002.033 1.788-1.938 1.788-1.938s-11.277 19.539 3.289 44.483c12.553 21.503 33.621 31.006 55.481 29.157a67.807 67.807 0 0011.519-1.747c50.935-12.314 45.398-73.814 45.398-73.814z"
      />
      <linearGradient
        id="firefox-original-p"
        gradientUnits="userSpaceOnUse"
        x1="-430.496"
        y1="915.535"
        x2="-419.681"
        y2="914.609"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset=".011" stopColor="#941403" />
        <stop offset=".897" stopColor="#E85C0A" />
      </linearGradient>
      <path
        fill="url(#firefox-original-p)"
        d="M45.619 32.149s2.201 6.015 7.138 5.996c9.42-.038 9.609.094 9.669 1.238.188 3.487-1.534 4.629-2.192 5.125-.661.494-9.629 5.694-9.959 7.182-.329 1.487-10.349-14.143-10.349-14.143l5.693-5.398z"
      />
      <linearGradient
        id="firefox-original-q"
        gradientUnits="userSpaceOnUse"
        x1="-447.82"
        y1="918.532"
        x2="-408.777"
        y2="913.652"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset=".011" stopColor="#941403" />
        <stop offset=".136" stopColor="#A32104" />
        <stop offset=".498" stopColor="#C84107" />
        <stop offset=".789" stopColor="#DF5509" />
        <stop offset=".972" stopColor="#E85C0A" />
      </linearGradient>
      <path
        fill="url(#firefox-original-q)"
        d="M50.634 38.634s3.06 3.907.746 5.47c-2.826 1.909 3.996 2.325 6.468.938 2.472-1.387 3.991-3.426 4.077-3.729.086-.304.898-3.043-4.262-2.088-3.262.603-4.458.742-7.029-.591z"
      />
      <linearGradient
        id="firefox-original-r"
        gradientUnits="userSpaceOnUse"
        x1="-423.63"
        y1="908.206"
        x2="-420.517"
        y2="909.576"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset="0" stopColor="#F2C8A9" />
        <stop offset="1" stopColor="#ffc" />
      </linearGradient>
      <path
        fill="url(#firefox-original-r)"
        d="M60.235 44.509c.5-.378 1.61-1.133 2.034-3-.309.125-.338-.23-.703-.076-6.927 7.227-7.193 2.194-10.974 3.208-3.446.943-4.221 2.237-4.366 2.337l.155.22c.993.505 1.944 2.113 2.66 3.55.699.833 1.168 1.242 1.235.94.329-1.485 9.3-6.685 9.959-7.179z"
      />
      <linearGradient
        id="firefox-original-s"
        gradientUnits="userSpaceOnUse"
        x1="-433.555"
        y1="870.093"
        x2="-381.191"
        y2="867.937"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset="0" stopColor="#B30000" />
        <stop offset="1" stopColor="#DF731B" />
      </linearGradient>
      <path
        fill="url(#firefox-original-s)"
        d="M8.478 50.25C7.064 53.218-2.012 68.555 12.8 94.081c14.495 24.985 39.58 33.144 65.191 27.601 7.311-1.582 15.74-7.302 21.113-11.5-3.452-8.706-1.409-8.379-3.259-7.234-20.631 12.773-37.032.173-49.726-1.437C-.58 95.593 8.642 50.158 8.642 50.158l-.164.092z"
      />
      <linearGradient
        id="firefox-original-t"
        gradientUnits="userSpaceOnUse"
        x1="-421.095"
        y1="878.22"
        x2="-393.792"
        y2="868.471"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset="0" stopColor="#941403" />
        <stop offset="1" stopColor="#DF731B" />
      </linearGradient>
      <path
        fill="url(#firefox-original-t)"
        d="M47.362 85.263c4.401 1.319 14.005.182 18.129-2.886 2.779-2.066 4.878-3.624 6.645-4.275-3.122-2.121-3.171.885-9.735 2.405-13.674 3.172-20.313-3.68-20.313-3.68.969 5.422 4.354 8.062 5.879 9-.404-.358-.616-.568-.605-.564z"
      />
      <linearGradient
        id="firefox-original-u"
        gradientUnits="userSpaceOnUse"
        x1="-483.865"
        y1="813.412"
        x2="-457.248"
        y2="813.412"
        gradientTransform="matrix(.999 .049 .049 -.999 450.28 926.467)"
      >
        <stop offset=".056" stopColor="#B30000" />
        <stop offset="1" stopColor="#DE5C01" />
      </linearGradient>
      <path
        fill="url(#firefox-original-u)"
        d="M32.535 110.025S21.152 97.18 17.974 82.795c-4.685-4.425-8.01-8.167-10.218-10.873 1.275 10.236 6.494 26.128 24.779 38.103z"
      />
      <linearGradient
        id="firefox-original-v"
        gradientUnits="userSpaceOnUse"
        x1="-301.198"
        y1="955.307"
        x2="-286.717"
        y2="910.443"
        gradientTransform="scale(1 -1) rotate(-6.83 -8816.783 -2227.993)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F6C08F" />
      </linearGradient>
      <path
        fill="url(#firefox-original-v)"
        d="M23.039 98.359s-7.855-11.184-4.91-20.679c2.65-8.538-.563-3.459-2.432-1.634-1.887 1.844-2.858-5.442-2.809-6.282l-.001-.027c-.119-.026-3.74 17.457 10.152 28.622z"
      />
      <linearGradient
        id="firefox-original-w"
        gradientUnits="userSpaceOnUse"
        x1="-476.095"
        y1="843.773"
        x2="-476.095"
        y2="793.626"
        gradientTransform="matrix(.999 .045 .045 -.999 451.05 929.576)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F6C08F" />
      </linearGradient>
      <path
        fill="url(#firefox-original-w)"
        d="M11.401 88.61s-1.791-22.698 3.87-25.906c8.99-5.094.75-3.903-1.857-2.489-2.634 1.427-2.39-7.968-2.018-8.86.365-.881-9.278 8.882.005 37.255z"
      />
      <path
        fill="#A40000"
        d="M50.73 21.819s-7.116 7.229-7.063 7.255c.054.025.204 9.277.437 11.9.853 1.008 3.51 7.558 1.476 6.104-2.078-1.484-.58-1.516-.398-.763v.037c-.139.065-5.165-10.879 5.548-24.533z"
      />
      <linearGradient
        id="firefox-original-x"
        gradientUnits="userSpaceOnUse"
        x1="-453.894"
        y1="921.626"
        x2="-459.335"
        y2="935.568"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset=".011" stopColor="#941403" />
        <stop offset=".472" stopColor="#E85C0A" />
        <stop offset="1" stopColor="#F9BD5F" />
      </linearGradient>
      <path
        fill="url(#firefox-original-x)"
        d="M16.877 16.25s-7.564 5.804-6.119 21.72c5.855-5.256 14.134-9.185 14.134-9.185-1.389-.876-7.762-5.975-8.015-12.535z"
      />
      <linearGradient
        id="firefox-original-y"
        gradientUnits="userSpaceOnUse"
        x1="-430.631"
        y1="918.428"
        x2="-417.593"
        y2="935.565"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset=".197" stopColor="#DE7210" />
        <stop offset=".843" stopColor="#F9BD5F" />
        <stop offset="1" stopColor="#FFFCCF" />
      </linearGradient>
      <path
        fill="url(#firefox-original-y)"
        d="M35.519 33.656L46.88 47.785c-3.277-13.875-.758-22.199 7.311-26.741 1.194-.673-16.858.243-18.672 12.612z"
      />
      <linearGradient
        id="firefox-original-z"
        gradientUnits="userSpaceOnUse"
        x1="-437.523"
        y1="895.036"
        x2="-424.307"
        y2="868.604"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset=".017" stopColor="#941403" />
        <stop offset=".5" stopColor="#E35100" />
        <stop offset="1" stopColor="#DF731B" />
      </linearGradient>
      <path
        fill="url(#firefox-original-z)"
        d="M27.514 68.56c1.938-12.208 18.927-10.413 18.927-10.413-.757.563-3.668.899-4.501 3.229-2.752 7.688-.127 24.483 17.01 31.527 1.807.745-34.299-6.303-31.436-24.343z"
      />
      <linearGradient
        id="firefox-original-A"
        gradientUnits="userSpaceOnUse"
        x1="-417.561"
        y1="911.246"
        x2="-414.261"
        y2="908.255"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset="0" stopColor="#EEA272" />
        <stop offset=".186" stopColor="#EFA777" />
        <stop offset=".406" stopColor="#F2B585" />
        <stop offset=".643" stopColor="#F6CD9C" />
        <stop offset=".89" stopColor="#FCEEBB" />
        <stop offset="1" stopColor="#ffc" />
      </linearGradient>
      <path
        fill="url(#firefox-original-A)"
        d="M62.171 41.84c-.083-.015-.157-.013-.194.037-.209.28-1.017 1.233-2.938 2.8-3.568 2.902-5.074 2.167-7.732 2.762-1.21.271-2.361 1.083-3.135 1.734.313.506.606 1.053.868 1.576.699.833 1.168 1.242 1.235.94.33-1.486 9.3-6.686 9.959-7.182.47-.351 1.464-1.049 1.937-2.667z"
      />
      <linearGradient
        id="firefox-original-B"
        gradientUnits="userSpaceOnUse"
        x1="-436.81"
        y1="904.181"
        x2="-421.649"
        y2="888.71"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset=".197" stopColor="#DF731B" />
        <stop offset=".843" stopColor="#F9BD5F" />
        <stop offset="1" stopColor="#FFFCCF" />
      </linearGradient>
      <path
        fill="url(#firefox-original-B)"
        d="M51.218 60.294c.101-2.58-.081-8.846-2.762-11.565-2.05-2.077-2.53-4.458-2.805-7.173C23.376 49.877 20.196 60.753 22.423 60.4c17.815-2.826 22.823-3.171 28.795-.106z"
      />
      <linearGradient
        id="firefox-original-C"
        gradientUnits="userSpaceOnUse"
        x1="311.259"
        y1="1736.858"
        x2="311.259"
        y2="1680.021"
        gradientTransform="scale(1 -1) rotate(-14.72 -6736.722 1996.747)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F6C08F" />
      </linearGradient>
      <path
        fill="url(#firefox-original-C)"
        d="M3.728 75.539s1.548-20.113 11.615-27.473c7.903-5.782 1.765-3.682-1.286-3.442-3.218.254-4.934 2.212-4.313 1.492l.031-.055c-.107-.124-7.555 6.127-6.047 29.478z"
      />
      <linearGradient
        id="firefox-original-D"
        gradientUnits="userSpaceOnUse"
        x1="-428.861"
        y1="929.136"
        x2="-448.077"
        y2="897.842"
        gradientTransform="matrix(.99 -.08 -.095 -1.173 528.218 1096.236)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F2C06E" />
      </linearGradient>
      <path
        fill="url(#firefox-original-D)"
        d="M2.667 60.087s5.395-17.125 16.297-16.979c7.23.096 1.495-6.111-.692-7.054-2.282-.977-2.827-.939-3.36-.467-.799.708-7.972.435-12.245 24.5z"
      />
      <linearGradient
        id="firefox-original-E"
        gradientUnits="userSpaceOnUse"
        x1="-391.562"
        y1="884.775"
        x2="-411.976"
        y2="880.876"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset=".005" stopColor="#FFFAEE" />
        <stop offset=".276" stopColor="#F5F89B" />
        <stop offset=".31" stopColor="#F3ED91" />
        <stop offset=".467" stopColor="#ECC267" />
        <stop offset=".618" stopColor="#E6A046" />
        <stop offset=".761" stopColor="#E2872E" />
        <stop offset=".892" stopColor="#E07820" />
        <stop offset="1" stopColor="#DF731B" />
      </linearGradient>
      <path
        fill="url(#firefox-original-E)"
        d="M76.213 76.849c.82-.803.249-3.888-4.904-5.757-4.675-1.699-11.973 2.619-14.138 3.471 0 0 8.266-1.548 11.365-1.033 4.202.7 5.677 5.281 7.677 3.319z"
      />
      <linearGradient
        id="firefox-original-F"
        gradientUnits="userSpaceOnUse"
        x1="-924.082"
        y1="388.59"
        x2="-924.082"
        y2="341.086"
        gradientTransform="matrix(.992 .126 .126 -.992 883.114 546.453)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F2C06E" />
      </linearGradient>
      <path
        fill="url(#firefox-original-F)"
        d="M10.631 71.208s-.895-16.836 6.649-24.026c5.924-5.647 1.065-3.243-1.438-2.713-2.64.56-3.85 2.367-3.413 1.704l.019-.049c-.101-.092-5.595 5.894-1.817 25.084z"
      />
      <linearGradient
        id="firefox-original-G"
        gradientUnits="userSpaceOnUse"
        x1="-955.606"
        y1="121.617"
        x2="-955.606"
        y2="74.12"
        gradientTransform="matrix(.932 .362 .362 -.932 862.955 499.986)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F2C06E" />
      </linearGradient>
      <path
        fill="url(#firefox-original-G)"
        d="M4.82 65.859s3.188-16.555 12.244-21.714c7.111-4.053 1.816-2.89-.742-2.979-2.697-.092-4.306 1.37-3.723.831l.029-.042c-.074-.115-6.85 4.371-7.808 23.904z"
      />
      <linearGradient
        id="firefox-original-H"
        gradientUnits="userSpaceOnUse"
        x1="-30.438"
        y1="1441.928"
        x2="-43.666"
        y2="1422.086"
        gradientTransform="scale(1 -1) rotate(35.88 2315.534 760.698)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F2C072" />
      </linearGradient>
      <path
        fill="url(#firefox-original-H)"
        d="M15.572 72.655s-1.743-10.035 2.014-14.974c2.998-3.941.366-2.014-1.026-1.445-1.452.593-2.002 1.764-1.804 1.334.191-.419-6.464 4.738.816 15.085z"
      />
      <linearGradient
        id="firefox-original-I"
        gradientUnits="userSpaceOnUse"
        x1="-23.279"
        y1="1448.429"
        x2="-36.506"
        y2="1428.588"
        gradientTransform="scale(1 -1) rotate(35.88 2315.534 760.698)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F2C072" />
      </linearGradient>
      <path
        fill="url(#firefox-original-I)"
        d="M17.564 63.193s-1.743-10.035 2.013-14.975c2.998-3.941.366-2.013-1.026-1.445-1.452.593-2.003 1.765-1.804 1.335.192-.42-6.462 4.737.817 15.085z"
      />
      <linearGradient
        id="firefox-original-J"
        gradientUnits="userSpaceOnUse"
        x1="-459.905"
        y1="914.636"
        x2="-465.692"
        y2="903.834"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#EED8A5" />
      </linearGradient>
      <path
        fill="url(#firefox-original-J)"
        d="M7.028 49.475s4.072-8.342 9.483-9.985c4.318-1.31 1.344-1.29.014-1.615-1.39-.337-2.421.232-2.046.021.367-.206-7.301.049-7.451 11.579z"
      />
      <linearGradient
        id="firefox-original-K"
        gradientUnits="userSpaceOnUse"
        x1="-460.486"
        y1="908.034"
        x2="-466.272"
        y2="897.234"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#EED8A5" />
      </linearGradient>
      <path
        fill="url(#firefox-original-K)"
        d="M6.447 56.076s4.071-8.342 9.483-9.984c4.318-1.31 1.344-1.292.013-1.617-1.39-.336-2.421.234-2.045.022.366-.206-7.302.05-7.451 11.579z"
      />
      <linearGradient
        id="firefox-original-L"
        gradientUnits="userSpaceOnUse"
        x1="-453.93"
        y1="912.618"
        x2="-459.523"
        y2="898.731"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F2C072" />
      </linearGradient>
      <path
        fill="url(#firefox-original-L)"
        d="M9.403 54.255s7.181-14.715 16.728-17.614c7.619-2.311 2.373-2.278.024-2.849-2.453-.594-4.271.413-3.61.039.647-.364-12.879.085-13.142 20.424z"
      />
      <linearGradient
        id="firefox-original-M"
        gradientUnits="userSpaceOnUse"
        x1="-451.803"
        y1="919.379"
        x2="-465.029"
        y2="899.54"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F2C072" />
      </linearGradient>
      <path
        fill="url(#firefox-original-M)"
        d="M14.312 46.33s4.466-9.152 10.404-10.955c4.739-1.438 1.475-1.417.015-1.772-1.526-.369-2.656.256-2.245.023.402-.228-8.011.052-8.174 12.704z"
      />
      <linearGradient
        id="firefox-original-N"
        gradientUnits="userSpaceOnUse"
        x1="-450.913"
        y1="915.373"
        x2="-462.969"
        y2="897.289"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F2C072" />
      </linearGradient>
      <path
        fill="url(#firefox-original-N)"
        d="M15.768 49.563s4.071-8.342 9.482-9.983c4.319-1.311 1.345-1.292.014-1.617-1.391-.337-2.422.233-2.046.022.365-.208-7.301.05-7.45 11.578z"
      />
      <linearGradient
        id="firefox-original-O"
        gradientUnits="userSpaceOnUse"
        x1="-412.122"
        y1="918.189"
        x2="-411.167"
        y2="916.487"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset="0" stopColor="#8B8B89" />
        <stop offset="1" stopColor="#120500" />
      </linearGradient>
      <path
        fill="url(#firefox-original-O)"
        d="M62.428 39.383c-.047-.87-.176-1.153-4.339-1.225.477.216 1.3.65 2.206 1.393 1.196.98 1.39 2.073 1.514 3.204.404-.769.701-1.833.619-3.372z"
      />
      <linearGradient
        id="firefox-original-P"
        gradientUnits="userSpaceOnUse"
        x1="-449.701"
        y1="923.971"
        x2="-449.701"
        y2="929.197"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F6C08F" />
      </linearGradient>
      <path
        fill="url(#firefox-original-P)"
        d="M37.982 27.764l-3.611 5.81s-14.438-2.265-26.679 9.577c-1.011.978 8.007-20.94 30.29-15.387z"
      />
      <linearGradient
        id="firefox-original-Q"
        gradientUnits="userSpaceOnUse"
        x1="-463.88"
        y1="875.39"
        x2="-452.942"
        y2="888.172"
        gradientTransform="matrix(.999 .04 .04 -.999 451.516 931.973)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F6C08F" />
      </linearGradient>
      <path
        fill="url(#firefox-original-Q)"
        d="M25.016 38.163s3.848-7.144 8.837-9.303c-2.579.081-8.37 2.098-8.837 9.303z"
      />
      <linearGradient
        id="firefox-original-R"
        gradientUnits="userSpaceOnUse"
        x1="-456.723"
        y1="918.976"
        x2="-462.51"
        y2="908.175"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#EED8A5" />
      </linearGradient>
      <path
        fill="url(#firefox-original-R)"
        d="M10.211 45.135s4.071-8.342 9.483-9.985c4.318-1.31 1.344-1.291.014-1.616-1.391-.336-2.421.234-2.046.021.365-.205-7.303.05-7.451 11.58z"
      />
      <linearGradient
        id="firefox-original-S"
        gradientUnits="userSpaceOnUse"
        x1="-490.528"
        y1="804.837"
        x2="-479.844"
        y2="817.323"
        gradientTransform="matrix(.995 .104 .104 -.995 420.84 891.22)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F6C08F" />
      </linearGradient>
      <path
        fill="url(#firefox-original-S)"
        d="M18.739 39.257s4.201-6.724 9.198-8.514c-2.516-.083-8.29 1.519-9.198 8.514z"
      />
      <linearGradient
        id="firefox-original-T"
        gradientUnits="userSpaceOnUse"
        x1="-489.629"
        y1="832.599"
        x2="-476.791"
        y2="830.84"
        gradientTransform="matrix(.996 .09 .09 -.996 426.311 899.606)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F6C08F" />
      </linearGradient>
      <path
        fill="url(#firefox-original-T)"
        d="M25.94 27.771s-3.167 1.384-8.752-.938l4.979 2.504 3.773-1.566z"
      />
      <linearGradient
        id="firefox-original-U"
        gradientUnits="userSpaceOnUse"
        x1="-465.214"
        y1="929.332"
        x2="-447.092"
        y2="926.85"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F6C08F" />
      </linearGradient>
      <path
        fill="url(#firefox-original-U)"
        d="M24.409 28.66s-4.22 1.635-12.345-.799l6.949 2.765c.861-.795 5.396-1.966 5.396-1.966z"
      />
      <linearGradient
        id="firefox-original-V"
        gradientUnits="userSpaceOnUse"
        x1="-487.129"
        y1="833.244"
        x2="-475.332"
        y2="831.628"
        gradientTransform="matrix(.996 .09 .09 -.996 426.311 899.606)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F6C08F" />
      </linearGradient>
      <path
        fill="url(#firefox-original-V)"
        d="M27.49 27.318s-2.801.853-7.977-1.149l4.979 2.502c.526-.464 2.998-1.353 2.998-1.353z"
      />
      <linearGradient
        id="firefox-original-W"
        gradientUnits="userSpaceOnUse"
        x1="-457.029"
        y1="925.518"
        x2="-467.666"
        y2="926.609"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F6C08F" />
      </linearGradient>
      <path
        fill="url(#firefox-original-W)"
        d="M18.753 30.54s-2.082 1.728-7.414 1.798l4.611.151 2.803-1.949z"
      />
      <linearGradient
        id="firefox-original-X"
        gradientUnits="userSpaceOnUse"
        x1="-495.902"
        y1="803.548"
        x2="-481.188"
        y2="820.743"
        gradientTransform="matrix(.995 .104 .104 -.995 420.84 891.22)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F6C08F" />
      </linearGradient>
      <path
        fill="url(#firefox-original-X)"
        d="M13.688 39.382S20.813 30.101 26.68 28c-2.955-.097-11.927 3.173-12.992 11.382z"
      />
      <linearGradient
        id="firefox-original-Y"
        gradientUnits="userSpaceOnUse"
        x1="-384.188"
        y1="835.447"
        x2="-355.369"
        y2="879.898"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset="0" stopColor="#DE5C01" />
        <stop offset=".736" stopColor="#FEFD00" />
        <stop offset=".778" stopColor="#FEFE26" />
        <stop offset=".837" stopColor="#FFFE54" />
        <stop offset=".889" stopColor="#FFFF76" />
        <stop offset=".932" stopColor="#FFFF8B" />
        <stop offset=".961" stopColor="#FFFF92" />
      </linearGradient>
      <path
        fill="url(#firefox-original-Y)"
        d="M124.039 55.208s.768 17.22-23.152 41.141c-2.659 2.658-17.093 16.18-16.585 20.236.178 1.435 37.87-5.781 39.737-61.377z"
      />
      <linearGradient
        id="firefox-original-Z"
        gradientUnits="userSpaceOnUse"
        x1="-367.43"
        y1="929.703"
        x2="-386.301"
        y2="937.991"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset="0" stopColor="#F79A09" />
        <stop offset=".736" stopColor="#FEFD00" />
        <stop offset=".778" stopColor="#FEFE26" />
        <stop offset=".837" stopColor="#FFFE54" />
        <stop offset=".889" stopColor="#FFFF76" />
        <stop offset=".932" stopColor="#FFFF8B" />
        <stop offset=".961" stopColor="#FFFF92" />
      </linearGradient>
      <path
        fill="url(#firefox-original-Z)"
        d="M77.663 14.705c28.813 2.214 34.391 22.931 34.393 21.662.074-20.139-27.335-21.669-34.393-21.662z"
      />
      <linearGradient
        id="firefox-original-aa"
        gradientUnits="userSpaceOnUse"
        x1="-354.754"
        y1="910.786"
        x2="-381.173"
        y2="935.312"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset="0" stopColor="#DE5C01" />
        <stop offset=".736" stopColor="#FEFD00" />
        <stop offset=".778" stopColor="#FEFE26" />
        <stop offset=".837" stopColor="#FFFE54" />
        <stop offset=".889" stopColor="#FFFF76" />
        <stop offset=".932" stopColor="#FFFF8B" />
        <stop offset=".961" stopColor="#FFFF92" />
      </linearGradient>
      <path
        fill="url(#firefox-original-aa)"
        d="M86.438 22.581s19.974 4.083 25.607 25.254c.747 2.804-2.407-17.199-1.434-15.3.972 1.908-8.038-9.321-24.173-9.954z"
      />
      <linearGradient
        id="firefox-original-ab"
        gradientUnits="userSpaceOnUse"
        x1="-460.091"
        y1="836.71"
        x2="-471.153"
        y2="848.15"
        gradientTransform="matrix(1 -.028 -.028 -1 593.415 868.62)"
      >
        <stop offset="0" stopColor="#F79A09" />
        <stop offset=".736" stopColor="#FEFD00" />
        <stop offset=".778" stopColor="#FEFE26" />
        <stop offset=".837" stopColor="#FFFE54" />
        <stop offset=".889" stopColor="#FFFF76" />
        <stop offset=".932" stopColor="#FFFF8B" />
        <stop offset=".961" stopColor="#FFFF92" />
      </linearGradient>
      <path
        fill="url(#firefox-original-ab)"
        d="M94.42 22.063s18.039 3.761 18.218 32.381c.126 20.258 3.128 7.605 6.106 3.053 2.568-3.934.813-8.726.751-8.713-.009.002-1.299-3.729-.43-2.148.039.07-1.211-1.03-1.203-1.031.202-.031-.693-20.572-23.442-23.542z"
      />
      <linearGradient
        id="firefox-original-ac"
        gradientUnits="userSpaceOnUse"
        x1="-359.183"
        y1="896.737"
        x2="-352.957"
        y2="918.154"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset="0" stopColor="#F79A09" />
        <stop offset=".736" stopColor="#FEFD00" />
        <stop offset=".778" stopColor="#FEFE26" />
        <stop offset=".837" stopColor="#FFFE54" />
        <stop offset=".889" stopColor="#FFFF76" />
        <stop offset=".932" stopColor="#FFFF8B" />
        <stop offset=".961" stopColor="#FFFF92" />
      </linearGradient>
      <path
        fill="url(#firefox-original-ac)"
        d="M114.733 25.94s6.479 16.878-.388 25.271c-2.241 2.739-2.492 16.772.246 15.483 2.745-1.291 2.149 7.452 1.789 8.446l-.006.031c.179.112 13.538-21.573-1.641-49.231z"
      />
      <linearGradient
        id="firefox-original-ad"
        gradientUnits="userSpaceOnUse"
        x1="-507.61"
        y1="782.982"
        x2="-507.837"
        y2="799.272"
        gradientTransform="scale(1 -1) rotate(2.35 20479.11 15387.252)"
      >
        <stop offset="0" stopColor="#F79A09" />
        <stop offset=".736" stopColor="#FEFD00" />
        <stop offset=".778" stopColor="#FEFE26" />
        <stop offset=".837" stopColor="#FFFE54" />
        <stop offset=".889" stopColor="#FFFF76" />
        <stop offset=".932" stopColor="#FFFF8B" />
        <stop offset=".961" stopColor="#FFFF92" />
      </linearGradient>
      <path
        fill="url(#firefox-original-ad)"
        d="M105.726 43.709s4.079 11.942-.192 20.479l3.231 7.215c2.369-5.82 5.387-18.131-3.039-27.694z"
      />
      <linearGradient
        id="firefox-original-ae"
        gradientUnits="userSpaceOnUse"
        x1="-615.186"
        y1="694.292"
        x2="-603.965"
        y2="716.393"
        gradientTransform="scale(1 -1) rotate(4.07 10630.367 10445.371)"
      >
        <stop offset="0" stopColor="#F79A09" />
        <stop offset=".736" stopColor="#FEFD00" />
        <stop offset=".778" stopColor="#FEFE26" />
        <stop offset=".837" stopColor="#FFFE54" />
        <stop offset=".889" stopColor="#FFFF76" />
        <stop offset=".932" stopColor="#FFFF8B" />
        <stop offset=".961" stopColor="#FFFF92" />
      </linearGradient>
      <path
        fill="url(#firefox-original-ae)"
        d="M112.899 42.289s2.821 18.954-7.357 36.065c.158 3.958-.537 7.54-1.49 10.491.444.583 1.037.982 1.82 1.052-.345.319-.689.618-1.022.901-.61.271-1.237.555-1.844.849l-.387.876a32.265 32.265 0 002.23-1.724c2.079-.919 3.95-1.631 3.946-1.636l-1.298.476c-.617.224-1.156.3-1.625.258 7.859-7.163 18.63-23.184 7.027-47.608zm-11.859 50.39c-.898.527-1.552 1.021-1.691 1.403-.104.278.509.117 1.568-.477.055-.319.1-.63.123-.926z"
      />
      <linearGradient
        id="firefox-original-af"
        gradientUnits="userSpaceOnUse"
        x1="-343.207"
        y1="938.701"
        x2="-341.697"
        y2="963.181"
        gradientTransform="scale(1 -1) rotate(4.07 14466.179 6568.719)"
      >
        <stop offset="0" stopColor="#DE5C01" />
        <stop offset=".736" stopColor="#FEFD00" />
        <stop offset=".778" stopColor="#FEFE26" />
        <stop offset=".837" stopColor="#FFFE54" />
        <stop offset=".889" stopColor="#FFFF76" />
        <stop offset=".932" stopColor="#FFFF8B" />
        <stop offset=".961" stopColor="#FFFF92" />
      </linearGradient>
      <path
        fill="url(#firefox-original-af)"
        d="M100.345 62.484s8.025 22.841-17.623 44.257c-1.513 1.263 10.411.722 11.454.249 3.074-1.396 6.707-10.714 6.278-9.6-.425 1.115 11.91-16.469-.109-34.906z"
      />
      <linearGradient
        id="firefox-original-ag"
        gradientUnits="userSpaceOnUse"
        x1="-414.032"
        y1="838.941"
        x2="-366.714"
        y2="867.224"
        gradientTransform="matrix(1 0 0 -1 472.5 957)"
      >
        <stop offset="0" stopColor="#B9120D" />
        <stop offset=".078" stopColor="#BB180D" />
        <stop offset=".182" stopColor="#C0290C" />
        <stop offset=".301" stopColor="#C8450A" />
        <stop offset=".431" stopColor="#D36C08" />
        <stop offset=".571" stopColor="#E29E05" />
        <stop offset=".715" stopColor="#F4DA02" />
        <stop offset=".792" stopColor="#FEFD00" />
        <stop offset=".814" stopColor="#FEFD07" />
        <stop offset=".846" stopColor="#FEFD1B" />
        <stop offset=".884" stopColor="#FEFE3C" />
        <stop offset=".927" stopColor="#FFFE69" />
        <stop offset=".974" stopColor="#FFFFA3" />
        <stop offset="1" stopColor="#FFFFC7" />
      </linearGradient>
      <path
        fill="url(#firefox-original-ag)"
        d="M111.568 76.972s-4.84 29.626-38.309 32.011c-13.104.935-31.921-2.133-30.254 2.866.517 1.549 2.98 8.011 8.602 9.509 15.214 4.059 55.693 2.73 59.961-44.386z"
      />
      <linearGradient
        id="firefox-original-ah"
        gradientUnits="userSpaceOnUse"
        x1="-451.41"
        y1="752.749"
        x2="-402.936"
        y2="746.182"
        gradientTransform="matrix(.995 .099 .099 -.995 429.966 890.404)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F6C08F" />
      </linearGradient>
      <path
        fill="url(#firefox-original-ah)"
        d="M83.656 99.393s-20.478 4.678-33.744-6.615c-12.139-10.335-6.117-1.637-4.47 2.654 1.691 4.401-7.823 1.039-9.252.331-1.425-.699 22.534 14.327 47.466 3.63z"
      />
      <linearGradient
        id="firefox-original-ai"
        gradientUnits="userSpaceOnUse"
        x1="-478.422"
        y1="705.757"
        x2="-422.136"
        y2="688.067"
        gradientTransform="matrix(.99 .145 .145 -.99 411.248 860.68)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F6C08F" />
      </linearGradient>
      <path
        fill="url(#firefox-original-ai)"
        d="M70.46 110.554S46.032 105.753 38.298 89.2c-6.609-14.141-4.86-3.764-5.158.959-.313 4.858-7.163-1.776-8.078-2.93l-.046-.042c-.136.089 12.599 20.054 45.444 23.367z"
      />
      <linearGradient
        id="firefox-original-aj"
        gradientUnits="userSpaceOnUse"
        x1="-986.556"
        y1="507.388"
        x2="-959.793"
        y2="456.149"
        gradientTransform="scale(1 -1) rotate(10.37 2796.5 5770.96)"
      >
        <stop offset=".056" stopColor="#DE7210" />
        <stop offset="1" stopColor="#F6C08F" />
      </linearGradient>
      <path
        fill="url(#firefox-original-aj)"
        d="M43.775 108.414s-11.667-9.037-16.928-21.429c-4.421-1.536-10.298-5.046-10.414-5.648 1.867 9.629 11.699 20.871 27.342 27.077z"
      />
    </svg>
  );
};

export default Firefox;
